import React from 'react';
import { UndoOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import AskAnotherQuestion from './AskAnotherQuestion';
import AskAnotherQuestionButton from './AskAnotherQuestionButton';
import AskAnotherQuestionWrapper from './AskAnotherQuestionWrapper';

interface StartNewFreshChatInputProps {
  isVisible: boolean;
  onAskNewQuestion?: () => void;
}

const StartNewFreshChatInput = function ({
  isVisible,
  onAskNewQuestion = undefined,
}: StartNewFreshChatInputProps) {
  const { t } = useTranslation();

  if (!isVisible) {
    return null;
  }

  return (
    <AskAnotherQuestionWrapper aria-label={t('askAnotherQuestion')}>
      <AskAnotherQuestionButton onClick={onAskNewQuestion} tabIndex={0}>
        <AskAnotherQuestion>
          {t('askAnotherQuestion')}
          {' '}
          <UndoOutlined aria-hidden="true" />
        </AskAnotherQuestion>
      </AskAnotherQuestionButton>
    </AskAnotherQuestionWrapper>
  );
};

export default StartNewFreshChatInput;
